import React from 'react'

import { navigate } from 'gatsby'

import { DEFAULT_LANG } from 'config/languages'

import { CategoriesList, Category, CategoryListEl } from './styles'

export default function PostCategories({ postCategories }) {
   function handleOnClick(event, cat) {
      const url =
         cat.node_locale === DEFAULT_LANG
            ? `/category/${cat.categoryName}/`
            : `/${cat.node_locale}/category/${cat.categoryName}/`

      event.stopPropagation()

      navigate(url)
   }
   if (postCategories.length === 0) return null
   return (
      <CategoriesList>
         {postCategories.map((cat) => {
            return (
               <CategoryListEl key={cat.categoryName}>
                  <Category onClick={(e) => handleOnClick(e, cat)}>{cat.categoryLabel}</Category>
               </CategoryListEl>
            )
         })}
      </CategoriesList>
   )
}
